import { useContext, useEffect, useState } from "react";
import React from "react";
import { allProductForStoreApi, createProductApi } from "../../Apis/ProductApi";
import { mainCategoryApi, subChildCatergoryApi } from "../../Apis/CategoryApi";
import { isVerifiedSellerApi } from "../../Apis/StoreApi";
import { UserAuthContext } from "../../App";
import { AddProductSVG, NoDataLogoSVG, ProductCategorySVG, ProductImageDropSVG } from "../../assets/svg/allSvg";

const MyProducts = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subCategoryOpen, setSubCategoryOpen] = useState(false);
  const [productType, setProductType] = useState(false);
  const [units, setUnits] = useState(false);
  // const [isOpen, setIsOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [addProduct, setAddProduct] = useState(true);
  const [productTitle, setproductTitle] = useState("");
  const [longDesc, setLongDesc] = useState("");
  const [stockStatus, setStockStatus] = useState("");
  const [stock, setStock] = useState(0);
  const [cancelPolicy, setCancelPolicy] = useState(null);
  const [refundPolicy, setRefundPolicy] = useState(null);
  const [shippingPolicy, setShippingPolicy] = useState(null);
  const [shortDesc, setShortDesc] = useState("");
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [mainCategoryList, setMainCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [childCategoryList, setChildCategoryList] = useState([]);
  const [sellerStatus, setSellerStatus] = useState(0);
  const [length, setLength] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [submitForm, setSubmitForm] = useState(false);
  const [viewProduct, setViewProduct] = useState(false);
  const [showImage, setShowImage] = useState("");
  const [color, setColor] = useState(0);
  const [allProductsData, setAllProductData] = useState([]);

  const [isOpen, setIsOpen] = useState(true);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);

  const [rows, setRows] = useState([{ min: "", max: "", price: "" }]);

  useEffect(() => {
    const savedRows = JSON.parse(localStorage.getItem("rows"));
    if (savedRows) {
      setRows(savedRows);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("rows", JSON.stringify(rows));
  }, [rows]);

  const addRow = () => {
    setRows([...rows, { min: "", max: "", price: "" }]);
  };

  const handleChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;
    setRows(newRows);
  };

  const toggleInformation = () => setIsOpen(!isOpen);
  const toggleMoq = () => setIsOpen2(!isOpen2);
  const toggleInventory = () => setIsOpen3(!isOpen3);
  const toggleShipping = () => setIsOpen4(!isOpen4);
  const togglePolicy = () => setIsOpen5(!isOpen5);

  const toggleViewProduct = () => {
    setViewProduct(!viewProduct);
  };

  function handleFiles(event) {
    const selectedFiles = event.target.files;
    if (files.length + selectedFiles.length > 4) {
      return;
    }
    setFiles([...files, ...selectedFiles]);
  }

  function handleUpload(event) {
    event.preventDefault();
    if (files.length === 0) return;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(files, { i }, files[i]);
    }

    fetch("url", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("success", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function handleDrop(event) {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);

    const limitedFiles = droppedFiles.slice(0, 4 - files.length);
    setFiles([...files, ...limitedFiles]);
  }

  function handleDelete(index) {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
  }

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleSubCategory = () => {
    setSubCategoryOpen(!subCategoryOpen);
  };

  const toggleProductType = () => {
    setProductType(!productType);
  };

  const toggleUnits = () => {
    setUnits(!units);
  };

  const toggleSubmitForm = () => {
    setSubmitForm(!submitForm);
  };

  const [selectedOption, setSelectedOption] = useState(null);
  const [categoryIsOpen, setCategoryIsOpen] = useState(false);

  const toggleCategoryOpen = () => {
    setCategoryIsOpen(!categoryIsOpen);
    setSubCategoryIsOpen(false);
    setChildCategoryIsOpen(false);
  };

  // main category selection dropdown
  const selectMainLabel = (option) => {
    setSelectedOption(option);
    setCategoryIsOpen(false);
  };

  // store selected dropdown option
  const [selectedSubOption, setSelectedSubOption] = useState(null);
  const [selectedChildOption, setSelectedChildOption] = useState(null);
  const [subCategoryIsOpen, setSubCategoryIsOpen] = useState(false);
  const [childCategoryIsOpen, setChildCategoryIsOpen] = useState(false);

  const toggleSubCategoryOpen = () => {
    setSubCategoryIsOpen(!subCategoryIsOpen);
  };

  const toggleChildCategoryOpen = () => {
    setChildCategoryIsOpen(!childCategoryIsOpen);
  };

  // sub category selection dropdown
  const selectSubLabel = (SubOption) => {
    setSelectedSubOption(SubOption);
    setSubCategoryIsOpen(false);
    setChildCategoryIsOpen(false);
  };

  // child category selection dropdown
  const selectChildLabel = (option) => {
    setSelectedChildOption(option);
    setChildCategoryIsOpen(false);
  };

  const [selectedUnitOption, setSelectedUnitOption] = useState(null);
  const [unitIsOpen, setUnitIsOpen] = useState(false);

  // measurment dropdown selection
  const toggleUnitOpen = () => {
    setUnitIsOpen(!unitIsOpen);
  };

  const selectUnitOption = (UnitOption) => {
    setSelectedUnitOption(UnitOption);
    setUnitIsOpen(false);
  };

  const [selectedDimensionOption, setSelectedDimensionOption] = useState(null);
  const [DimensionIsOpen, setDimensionIsOpen] = useState(false);

  const toggleDimensionOpen = () => {
    setDimensionIsOpen(!DimensionIsOpen);
  };

  const selectDimensionOption = (DimensionOption) => {
    setSelectedDimensionOption(DimensionOption);
    setDimensionIsOpen(false);
  };

  const getSellerVerifiedStatus = async () => {
    const response = await isVerifiedSellerApi(10);
    setSellerStatus(response?.store?.isVerified);
  };

  function handleFiles(e) {
    const selectedFiles = Array.from(e.target.files);
    const hasVideo = selectedFiles.some(file => file.type.startsWith('video/'));
    
  
    // Your existing logic to update files state
    setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
  }
  
  // fetch main catergory
  const getMainCategory = async () => {
    const response = await mainCategoryApi();
    const newArray = [];
    for (const element of response?.category)
      newArray.push({
        value: element,
        label: element,
      });
    setMainCategoryList(newArray);
  };

  // currrent user
  const { userUid } = useContext(UserAuthContext);

  const allSellerProductFromStore = async () => {
    const response = await allProductForStoreApi(userUid?.currentUser?.uid); // change to dynamic
    setAllProductData(response?.products || []);
  };

  useEffect(() => {
    getMainCategory();
    getSellerVerifiedStatus();
    allSellerProductFromStore();
  }, []);

  const UnitOptions = [
    { value: "unit", label: "unit" },
    { value: "kg", label: "kg" },
    { value: "l", label: "l" },
  ];

  const DimensionOptions = [
    { value: "Length", label: "Length" },
    { value: "Width", label: "Width" },
    { value: "Height", label: "Height" },
  ];

  // fetch sub and child category
  const handleSubCategory = async () => {
    const response = await subChildCatergoryApi(selectedOption?.value);
    const newArray = [];
    for (const element of response?.category) {
      if (element?.subCategory)
        newArray.push({
          value: element?.subCategory,
          label: element?.subCategory,
        });
    }
    setSubCategoryList(newArray);
    setChildCategoryList(response?.category);
  };

  useEffect(() => {
    if (selectedSubOption?.value) {
      const filteredChild = childCategoryList?.filter(
        (item) => item?.subCategory === selectedSubOption?.value
      );

      const newArray = [];

      if (filteredChild.length > 0) {
        const element = filteredChild[0]?.childCategory;

        for (let i = 0; i < element?.length; i++) {
          newArray.push({
            value: element[i]?.childCategory,
            label: element[i]?.childCategory,
            categoryID: element[i]?.categoryID,
          });
        }
      }
      setChildCategoryList(newArray);
    }
  }, [selectedSubOption?.value]);

  //  trigger on main category selection
  useEffect(() => {
    if (selectedOption?.value) handleSubCategory();
  }, [selectedOption?.value]);

  const handleCreateProduct = async () => {
    const data = {
      productID: 3624827,
      storeID: userUid?.currentUser?.uid, // change to dynamic
      categoryID: selectedChildOption?.categoryID,
      productTitle,
      minPrice,
      maxPrice,
      images: files,
      stock,
      minMoq: 0,
      maxMoq: 0,
      attributes: null,
      packageDimension: JSON.stringify({
        Length: length,
        Width: width,
        Height: height,
      }),
      longDesc,
      shortDesc,
      tags: "top,featured",
      cancelPolicy,
      refundPolicy,
      shippingPolicy,
    };

    await createProductApi(data);
    alert("Product created successfully");
    setViewProduct(false);
  };

  // preview the image
  const handleImageClick = (index) => {
    console.log(files[index].imgSrc);
    setColor(index);
  };

  const dateConversion = (timestamp) => {
    const date = new Date(timestamp);

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Extract the day, month, and year from the date object
    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;
  };

  return (
    <div className="w-[1014px] h-auto bg-[#FFF9F2] rounded-r-[10px] flex flex-col pt-[36px] pl-[35px] pr-[27px] pb-[19px]">
      {addProduct ? (
        <>
          <div className="w-full h-auto flex flex-col justify-between">
            <div className="w-full h-[38px] flex flex-row justify-between">
              <div className="w-[167px] flex flex-col items-start justify-between">
                <h3 className="w-[110px] h-[24px] text-black text-start font-semibold text-[16px]">
                  My Products
                </h3>
                <hr className="w-[167px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />
              </div>
              <div className="w-[326px] h-[38px] flex gap-x-[26px] items-center justify-between">
                <p className="w-[145px] h-[21px] font-semibold text-[14px] text-black">
                  Total Products :{" "}
                  <span className="text-[#FF6300] text-[14px] font-semibold">
                    {allProductsData.length}/10
                  </span>
                </p>
                <button
                  className="w-[157px] h-[38px] bg-[#FF6300] font-semibold text-[12px] text-white flex items-center justify-center rounded-[5px] gap-x-[10px]"
                  onClick={() => setAddProduct((prev) => !prev)}
                >
                  {AddProductSVG}
                  <p className="w-[105px] h-[18px]">Add New Product</p>
                </button>
              </div>
            </div>

            {allProductsData && allProductsData.length > 0 ? (
              <div className=" rounded-[10px] mt-[24px]">
                <table className="min-w-full bg-white drop-shadow-[0_0px_1px_rgba(0,0,0,0.20)]">
                  <thead className="bg-[#F2F2F2] font-semibold text-[14px] h-[70px]">
                    <tr>
                      <th className="px-4 py-2 font-semibold">Product</th>
                      <th className="px-4 py-2 font-semibold">Price</th>
                      <th className="px-4 py-2 font-semibold">
                        Stock Quantity
                      </th>
                      <th className="px-4 py-2 font-semibold">Stock Status</th>
                      <th className="px-4 py-2 w-[110px] font-semibold">
                        Units Sold{" "}
                        <span className="h-[21px] font-medium text-[12px] text-black">
                          (Till Date)
                        </span>
                      </th>
                      <th className="px-4 py-2 w-[110px] font-semibold">
                        Publish Status
                      </th>
                      <th className="px-4 py-2 font-semibold">Action</th>
                    </tr>
                  </thead>
                  <tbody className="[&>*:nth-child(even)]:bg-[#F8F8F8] [&>*:nth-child(odd)]:bg-white font-medium text-[12px]">
                    {allProductsData.map((products, index) => (
                      <tr key={index} className="h-[80px]">
                        <td className="px-4 py-2 flex items-center h-[80px]">
                          <img
                            src={products.images[0]}
                            alt="Product"
                            className="w-[34px] h-[34px] mr-[15px]"
                          />
                          {products?.productTitle?.length > 30 ? (
                            <>{products?.productTitle?.slice(0, 30)}...</>
                          ) : (
                            products?.productTitle
                          )}
                        </td>
                        <td className="px-4 py-2 w-[90px] text-center">
                          {products?.maxPrice}
                        </td>
                        <td className="px-4 py-2 text-center w-[120px]">
                          <div>{products?.stock || <>-</>}</div>
                        </td>
                        <td className="px-4 py-2 text-center">
                          {products?.stockStatus || <>-</>}
                        </td>
                        <td className="px-4 py-2 text-center">
                          {products?.sold || 0}
                        </td>
                        <td className="px-4 py-2 text-center">
                          {products?.adminVerified === 0 ? 'Pending' : 'Published'}
                          {dateConversion(products?.createdOn)}
                        </td>
                        <td className="px-4 py-2">
                          <button className="w-[74px] h-[20px] text-[#FF6300] font-medium text-[12px]">
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center gap-y-[41px] h-[800px]">
                {NoDataLogoSVG}
                <p className="font-semibold text-[20px] text-black text-center">
                  No Products available !!
                </p>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          {sellerStatus === 0 && (
            <div class="ml-[226px] fixed w-[980px] h-[935px] rounded-tr-lg rounded-br-lg inset-0 flex items-center pb-[160px] justify-center bg-gray-900 bg-opacity-90 z-50">
              <div class="bg-white rounded-lg p-8 max-w-sm mx-auto">
                <div class="text-center">
                  <h2 class="text-lg font-bold mb-4">Verify First</h2>
                  <p class="text-gray-600">
                    Please verify your account before proceeding.
                  </p>
                </div>
                <div class="mt-6 text-center">
                  <button
                    onClick={() => setAddProduct(true)}
                    class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                  >
                    Verify Now
                  </button>
                </div>
              </div>
            </div>
          )}
          <h3 className="w-[140px] h-[24px] text-black text-start font-semibold text-[16px]">
            Add New Product
          </h3>
          <hr className="w-[167px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />
          <div className="flex flex-col gap-y-[18px] w-full h-auto mt-[22px] overflow-y-scroll">
            <div className="w-[948px] h-auto bg-white rounded-[10px] py-[20px] pl-[24px] pr-[20px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={toggleInformation}
              >
                <h4 className="w-[144px] h-[21px] text-[#FF6300] font-semibold text-[14px]">
                  General Information
                </h4>
                <button className="w-[31px] h-[31px] bg-white rounded-full border flex items-center justify-center">
                  <svg
                    width="19"
                    height="19"
                    className={`w-6 h-6 transition-transform duration-300 transform ${isOpen ? "rotate-0" : "rotate-180"
                      }`}
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.07129 11.6111L9.34907 6.33331L14.6268 11.6111"
                      stroke="#FF6300"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              {isOpen && (
                <>
                  <div className="flex flex-row mt-[18px]">
                    <div className="w-[293px] h-full flex flex-col">
                      <h3 className="w-[118px] h-[21px] text-black text-start font-semibold text-[14px]">
                        Images
                      </h3>
                      <p className="w-[187px] h-[18px] text-black text-start font-medium text-[12px] mt-[7px]">
                        Add upto 4 product images
                      </p>


   

                      <div className="w-[293px] h-[300px] bg-white rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] mt-[14px] flex flex-col items-start justify-start gap-y-[10px] overflow-y-auto">
  {files.slice(0, 5).map((file, index) => {
    const truncatedName = file.name.length > 10 ? `${file.name.substring(0, 10)}...` : file.name;
    return (
      <div
        key={index}
        className="w-[286px] h-[59px] bg-white rounded-[5px] py-[8px] px-[15px] flex items-center"
      >
        <div className="w-full flex flex-row items-center justify-between">
          <div className="flex items-center gap-x-[20px]">
            <img
              className="w-[30px] h-[38px]"
              src={URL.createObjectURL(file)}
              alt={`Product ${index}`}
            />
            <p className="w-[85px] h-[18px] font-medium text-start text-black text-[12px]">
              {truncatedName}
            </p>
          </div>
          <button onClick={() => handleDelete(index)}>
            <div className="">
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9375 3.59375H10.0625C9.87188 3.59375 9.68906 3.51802 9.55427 3.38323C9.41948 3.24844 9.34375 3.06562 9.34375 2.875C9.34375 2.68438 9.41948 2.50156 9.55427 2.36677C9.68906 2.23198 9.87188 2.15625 10.0625 2.15625H12.9375C13.1281 2.15625 13.3109 2.23198 13.4457 2.36677C13.5805 2.50156 13.6562 2.68438 13.6562 2.875C13.6562 3.06562 13.5805 3.24844 13.4457 3.38323C13.3109 3.51802 13.1281 3.59375 12.9375 3.59375Z"
                  fill="black"
                />
                <path
                  d="M18.6875 4.3125H4.3125C4.12188 4.3125 3.93906 4.38823 3.80427 4.52302C3.66948 4.65781 3.59375 4.84063 3.59375 5.03125C3.59375 5.22187 3.66948 5.40469 3.80427 5.53948C3.93906 5.67427 4.12188 5.75 4.3125 5.75H5.03125V18.6875C5.03182 19.2592 5.25918 19.8073 5.66343 20.2116C6.06768 20.6158 6.6158 20.8432 7.1875 20.8438H15.8125C16.3842 20.8432 16.9323 20.6158 17.3366 20.2116C17.7408 19.8073 17.9682 19.2592 17.9688 18.6875V5.75H18.6875C18.8781 5.75 19.0609 5.67427 19.1957 5.53948C19.3305 5.40469 19.4062 5.22187 19.4062 5.03125C19.4062 4.84063 19.3305 4.65781 19.1957 4.52302C19.0609 4.38823 18.8781 4.3125 18.6875 4.3125ZM16.5312 18.6875C16.5312 18.8781 16.4555 19.0609 16.3207 19.1957C16.1859 19.3305 16.0031 19.4062 15.8125 19.4062H7.1875C6.99688 19.4062 6.81406 19.3305 6.67927 19.1957C6.54448 19.0609 6.46875 18.8781 6.46875 18.6875V5.75H16.5312V18.6875Z"
                  fill="black"
                />
                <path
                  d="M9.34375 17.25C9.15313 17.25 8.97031 17.1743 8.83552 17.0395C8.70073 16.9047 8.625 16.7219 8.625 16.5312V8.625C8.625 8.43438 8.70073 8.25156 8.83552 8.11677C8.97031 7.98198 9.15313 7.90625 9.34375 7.90625C9.53437 7.90625 9.71719 7.98198 9.85198 8.11677C9.98677 8.25156 10.0625 8.43438 10.0625 8.625V16.5312C10.0625 16.7219 9.98677 16.9047 9.85198 17.0395C9.71719 17.1743 9.53437 17.25 9.34375 17.25ZM13.6562 17.25C13.4656 17.25 13.2828 17.1743 13.148 17.0395C13.0132 16.9047 12.9375 16.7219 12.9375 16.5312V8.625C12.9375 8.43438 13.0132 8.25156 13.148 8.11677C13.2828 7.98198 13.4656 7.90625 13.6562 7.90625C13.8469 7.90625 14.0297 7.98198 14.1645 8.11677C14.2993 8.25156 14.375 8.43438 14.375 8.625V16.5312C14.375 16.7219 14.2993 16.9047 14.1645 17.0395C14.0297 17.1743 13.8469 17.25 13.6562 17.25Z"
                  fill="black"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    );
  })}

  {files.length < 5 && (
    <div className="w-[286px] h-[59px] bg-white rounded-[5px] py-[8px] px-[15px] flex items-center">
      <form onSubmit={handleUpload} className="">
        <div
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <input
            multiple
            type="file"
            accept="image/*,video/*"
            name="file"
            onChange={handleFiles}
            className="hidden"
          />
          <button
            type="button"
            onClick={() =>
              document
                .querySelector("input[type=file]")
                .click()
            }
            className="flex items-center gap-x-[14px]"
          >
            {ProductImageDropSVG}
            <p className="w-[103px] h-[18px] font-semibold text-[#FF6300] text-start text-[12px]">
              click here to add
            </p>
          </button>
        </div>
      </form>
    </div>
  )}
</div>




                      <h3 className="w-[67px] h-[21px] text-black text-start font-semibold text-[14px] mt-[21px]">
                        Category
                      </h3>
                      <div className="relative">
                        <button
                          onClick={toggleCategoryOpen}
                          className="flex flex-row items-center justify-between border-black w-[293px] h-[42px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] p-[12px] mt-[11px] font-medium text-[12px] text-black text-start"
                        >
                          {selectedOption
                            ? selectedOption.label
                            : "Select Category"}
                          {ProductCategorySVG}
                        </button>
                        {categoryIsOpen && (
                          <div className="absolute z-10 mt-2 w-full bg-white border border-gray-300 rounded-[5px] max-h-[200px] overflow-y-auto">
                            {mainCategoryList.map((option) => (
                              <button
                                key={option.value}
                                onClick={() => selectMainLabel(option)}
                                className="block w-full py-2 px-4 font-medium text-[12px] text-black hover:text-[#FF6300] focus:outline-none"
                              >
                                {option.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      <h3 className="w-[104px] h-[21px] text-black text-start font-semibold text-[14px] mt-[21px]">
                        Sub Category
                      </h3>
                      <div className="relative">
                        <button
                          onClick={toggleSubCategoryOpen}
                          className="flex flex-row items-center justify-between border-black w-[293px] h-[42px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] p-[12px] mt-[11px] font-medium text-[12px] text-black text-start"
                        >
                          {selectedSubOption
                            ? selectedSubOption.label
                            : "Select Sub Category"}
                          {ProductCategorySVG}
                        </button>
                        {subCategoryIsOpen && (
                          <div className="absolute z-10 mt-2 w-full bg-white border border-gray-300 rounded-[5px] max-h-[200px] overflow-y-auto">
                            {subCategoryList.map((SubCategory) => (
                              <button
                                onClick={() => selectSubLabel(SubCategory)}
                                className="block w-full py-2 px-4 font-medium text-[12px] text-black hover:text-[#FF6300] focus:outline-none"
                              >
                                {SubCategory.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      <h3 className="w-[144px] h-[21px] text-black text-start font-semibold text-[14px] mt-[21px]">
                        Child Category
                      </h3>
                      <div className="relative">
                        <button
                          onClick={toggleChildCategoryOpen}
                          className="flex flex-row items-center justify-between border-black w-[293px] h-[42px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] p-[12px] mt-[11px] font-medium text-[12px] text-black text-start"
                        >
                          {selectedChildOption
                            ? selectedChildOption.label
                            : "Select Child Category"}
                          {ProductCategorySVG}
                        </button>
                        {childCategoryIsOpen && (
                          <div className="absolute z-10 mt-2 w-full bg-white border border-gray-300 rounded-[5px] max-h-[200px] overflow-y-auto">
                            {childCategoryList.map((ChildOption) => (
                              <button
                                key={ChildOption.value}
                                onClick={() => selectChildLabel(ChildOption)}
                                className="block w-full py-2 px-4 font-medium text-[12px] text-black hover:text-[#FF6300] focus:outline-none"
                              >
                                {ChildOption.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <hr className="w-[1px] h-[562px] rounded-full bg-[#E3E3E3] ml-[27px]" />

                    <div className="w-[565px] h-[562px] flex flex-col ml-[17px]">
                      <h3 className="w-[103px] h-[21px] font-semibold text-[14px] text-black text-start">
                        Product Name
                      </h3>
                      <input
                        onChange={(text) => setproductTitle(text.target.value)}
                        type="text"
                        placeholder="Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM"
                        className="w-[565px] h-[42px] rounded-[5px] p-[12px] font-medium text-black text-start text-[12px] border mt-[8px]"
                      />
                      <div className="flex items-center justify-between mt-[22px]">
                        <div className="flex flex-col gap-x-[8px]">
                          <h4 className="w-[94px] h-[21px] font-semibold text-[14px] text-black text-start">
                            Product Type
                          </h4>
                          <div className="relative">
                            <button
                              onClick={toggleUnitOpen}
                              className="flex flex-row items-center justify-between border-black w-[181px] h-[42px] bg-white drop-shadow-[0_0px_1px_rgba(0,0,0,0.15)] rounded-[5px] p-[12px] mt-[11px] font-medium text-[12px] text-black text-start"
                            >
                              {selectedUnitOption
                                ? selectedUnitOption.label
                                : "Units"}
                              <svg
                                width="9"
                                height="6"
                                viewBox="0 0 9 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.81795 5.36389C4.20208 5.72215 4.79792 5.72215 5.18205 5.36389L8.27282 2.48131C8.9367 1.86214 8.49857 0.75 7.59077 0.75H1.40923C0.501428 0.75 0.0632989 1.86214 0.72718 2.48131L3.81795 5.36389Z"
                                  fill="black"
                                />
                              </svg>
                            </button>
                            {unitIsOpen && (
                              <div className="absolute z-10 mt-2 w-full bg-white border border-gray-300 rounded-[5px]">
                                {UnitOptions.map((UnitOption) => (
                                  <button
                                    key={UnitOption.value}
                                    onClick={() => selectUnitOption(UnitOption)}
                                    className="block w-full py-2 px-4 font-medium text-[12px] text-black hover:text-[#FF6300] focus:outline-none"
                                  >
                                    {UnitOption.label}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div>
                          <h4 className="w-[95px] h-[21px] font-semibold text-[14px] text-black text-start">
                            Product Price
                          </h4>
                          <input
                            onChange={(text) => setMaxPrice(text.target.value)}
                            type="text"
                            placeholder="₹ 50,000"
                            className="w-[181px] h-[42px] border rounded-[5px] text-black p-[12px] font-medium text-[12px] mt-[8px]"
                          />
                        </div>
                        <div>
                          <h4 className="w-[170px] h-[21px] font-semibold text-[14px] text-black text-start">
                            Discount Price{" "}
                            <span className="w-[64px] h-[18px] text-black text-start font-medium text-[12px]">
                              (optional)
                            </span>
                          </h4>
                          <input
                            onChange={(text) => setMinPrice(text.target.value)}
                            type="text"
                            placeholder="₹ 45,000"
                            className="w-[181px] h-[42px] border rounded-[5px] text-black p-[12px] font-medium text-[12px] mt-[8px]"
                          />
                        </div>
                      </div>
                      <h3 className="w-[92px] h-[21px] font-semibold text-[14px] text-black text-start mt-[22px]">
                        Top Features
                      </h3>
                      <textarea
                        onChange={(text) => setShortDesc(text.target.value)}
                        name="TopFeature"
                        id="TopFeature"
                        rows={5}
                        placeholder="Mention top features of your product."
                        className="w-[565px] h-[141px] p-[12px] border rounded-[5px] placeholder:w-[541px] placeholder:h-[117px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-start mt-[8px] text-black resize-none"
                      ></textarea>
                      <h3 className="w-[141px] h-[21px] font-semibold text-[14px] text-black text-start mt-[22px]">
                        Product Description
                      </h3>
                      <textarea
                        onChange={(text) => setLongDesc(text.target.value)}
                        name="ProductDesc"
                        id="ProductDesc"
                        rows={5}
                        placeholder="Describe your product in brief."
                        className="w-[565px] h-[155px] p-[12px] border rounded-[5px] placeholder:w-[541px] placeholder:h-[131px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black resize-none mt-[8px]"
                      ></textarea>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="w-[948px] h-auto bg-white rounded-[10px] py-[20px] pl-[24px] pr-[20px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={toggleMoq}
              >
                <h4 className="w-[178px] h-[21px] text-[#FF6300] font-semibold text-[14px]">
                  Minimum Order Quantity
                </h4>
                <div className="flex flex-row items-center justify-end w-[371px] h-[42px] gap-x-[13px]">
                  <p className="w-[181px] h-[18px] font-semibold text-[12px] text-start text-black">
                    Set Minimum Order Quantity :
                  </p>
                  <input
                    type="text"
                    placeholder="5"
                    className="py-[12px] px-[18px] text-black placeholder:w-[8px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] w-[133px] h-[42px] rounded-[5px] border"
                  />
                  <button className="w-[31px] h-[31px] bg-white rounded-full border flex items-center justify-center">
                    <svg
                      width="19"
                      height="19"
                      className={`w-6 h-6 transition-transform duration-300 transform ${isOpen2 ? "rotate-0" : "rotate-180"
                        }`}
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.07129 11.6111L9.34907 6.33331L14.6268 11.6111"
                        stroke="#FF6300"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              {isOpen2 && (
                <>
                  <div className="w-[904px] h-auto mt-[25px] flex flex-col z-50 overflow-y-scroll">
                    <div className="flex items-center justify-between w-full h-[32px]">
                      <p className="w-[112px] h-[21px] font-semibold text-black text-start text-[14px]">
                        Quantity Range
                      </p>
                      <button
                        className="w-[86px] h-[32px] font-semibold text-[12px] flex items-center justify-center text-white bg-[#FF6300] rounded-[5px]"
                        onClick={addRow}
                      >
                        Add Row
                      </button>
                    </div>
                    <hr className="w-full bg-[#E3E3E3] rounded-full h-[1px] mt-[13px]" />
                    <div className="w-full h-auto mt-[16px] flex flex-col">
                      <div className="flex items-center justify-between font-semibold text-[12px] text-black">
                        <div className="flex flex-row w-[453px] justify-end">
                          <h4 className="w-[223px] h-[18px] text-start">
                            Minimum
                          </h4>
                          <h4 className="w-[210px] h-[18px] text-start">
                            Maximum
                          </h4>
                        </div>
                        <h4 className="w-[266px] h-[18px] text-start">Price</h4>
                      </div>
                      {rows.map((row, index) => (
                        <div
                          key={index}
                          className="w-full flex items-center justify-between mt-[8px]"
                        >
                          <div className="flex flex-row items-center justify-start gap-x-[13px]">
                            <p className="w-[8px] h-[18px] font-medium text-[12px] text-black text-start">
                              {index + 1}
                            </p>
                            <input
                              type="text"
                              className="w-[210px] h-[42px] rounded-[5px] placeholder:w-[8px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                              placeholder="5"
                              value={row.min}
                              onChange={(e) =>
                                handleChange(index, "min", e.target.value)
                              }
                            />
                            <input
                              type="text"
                              className="w-[210px] h-[42px] rounded-[5px] placeholder:w-[16px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                              placeholder="50"
                              value={row.max}
                              onChange={(e) =>
                                handleChange(index, "max", e.target.value)
                              }
                            />
                          </div>
                          <input
                            type="text"
                            className="w-[266px] h-[42px] rounded-[5px] placeholder:w-[92px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                            placeholder="₹ 50000"
                            value={row.price}
                            onChange={(e) =>
                              handleChange(index, "price", e.target.value)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="w-[948px] h-auto bg-white rounded-[10px] py-[20px] pl-[24px] pr-[20px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={toggleInventory}
              >
                <h4 className="w-[68px] h-[21px] text-[#FF6300] font-semibold text-[14px]">
                  Inventory
                </h4>
                <button className="w-[31px] h-[31px] bg-white rounded-full border flex items-center justify-center">
                  <svg
                    width="19"
                    height="19"
                    className={`w-6 h-6 transition-transform duration-300 transform ${isOpen3 ? "rotate-0" : "rotate-180"
                      }`}
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.07129 11.6111L9.34907 6.33331L14.6268 11.6111"
                      stroke="#FF6300"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              {isOpen3 && (
                <>
                  <div className="w-[904px] h-[68px] mt-[16px] flex flex-col">
                    <div className="flex items-center justify-between w-full h-[18px] font-semibold text-[12px] text-black">
                      <p className="w-[454px] h-[18px] text-start">
                        Stock Status
                      </p>
                      <p className="w-[409px] h-[18px] text-start">
                        Stock Quantity
                      </p>
                    </div>
                    <div className="flex flex-row items-center justify-between mt-[8px]">
                      <input
                        onChange={(text) => setStockStatus(text.target.value)}
                        type="text"
                        className="w-[454px] h-[42px] rounded-[5px] placeholder:w-[48px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                        placeholder="In Stock"
                      />
                      <input
                        onChange={(text) => setStock(text.target.value)}
                        type="text"
                        className="w-[409px] h-[42px] rounded-[5px] placeholder:w-[16px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                        placeholder="50"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="w-[948px] h-auto bg-white rounded-[10px] py-[20px] pl-[24px] pr-[20px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
              <div className="flex justify-between items-center cursor-pointer">
                <h4 className="w-[68px] h-[21px] text-[#FF6300] font-semibold text-[14px]">
                  Shipping
                </h4>
                <div className="flex flex-row items-center justify-end w-[371px] h-[42px] gap-x-[13px]">
                  <p className="w-[121px] h-[18px] font-semibold text-[12px] text-start text-black">
                    Set Dimension Unit :
                  </p>
                  <div className="relative">
                    <button
                      onClick={toggleDimensionOpen}
                      className="flex flex-row items-center justify-between border-black w-[164px] h-[42px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] p-[12px] font-medium text-[12px] text-black text-start"
                    >
                      {selectedDimensionOption
                        ? selectedDimensionOption.label
                        : "Select Unit"}
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.81795 5.36389C4.20208 5.72215 4.79792 5.72215 5.18205 5.36389L8.27282 2.48131C8.9367 1.86214 8.49857 0.75 7.59077 0.75H1.40923C0.501428 0.75 0.0632989 1.86214 0.72718 2.48131L3.81795 5.36389Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                    {DimensionIsOpen && (
                      <div className="absolute z-10 mt-2 w-full bg-white border border-gray-300 rounded-[5px]">
                        {DimensionOptions.map((DimOption) => (
                          <button
                            key={DimOption.value}
                            onClick={() => selectDimensionOption(DimOption)}
                            className="block w-full py-2 px-4 font-medium text-[12px] text-black hover:text-[#FF6300] focus:outline-none"
                          >
                            {DimOption.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                  <button
                    className="w-[31px] h-[31px] bg-white rounded-full border flex items-center justify-center"
                    onClick={toggleShipping}
                  >
                    <svg
                      width="19"
                      height="19"
                      className={`w-6 h-6 transition-transform duration-300 transform ${isOpen4 ? "rotate-0" : "rotate-180"
                        }`}
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.07129 11.6111L9.34907 6.33331L14.6268 11.6111"
                        stroke="#FF6300"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              {isOpen4 && (
                <>
                  <div className="w-[904px] h-[102px] mt-[11px] flex flex-col">
                    <h3 className="w-[150px] h-[21px] font-semibold text-[14px] text-start">
                      Package Dimensions
                    </h3>
                    <div className="flex items-center justify-between w-full h-[68px] mt-[13px]">
                      <div className="flex flex-col h-[68px] items-center text-start justify-between">
                        <h4 className="w-[287px] h-[18px] font-semibold text-start text-black text-[12px]">
                          Length
                        </h4>
                        <input
                          onChange={(text) =>
                            setLength(text.currentTarget.value)
                          }
                          type="text"
                          className="w-[287px] h-[42px] rounded-[5px] placeholder:w-[12px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                          placeholder="51"
                        />
                      </div>
                      <div className="flex flex-col h-[68px] items-center text-start justify-between">
                        <h4 className="w-[286px] h-[18px] font-semibold text-start text-black text-[12px]">
                          Width
                        </h4>
                        <input
                          onChange={(text) =>
                            setWidth(text.currentTarget.value)
                          }
                          type="text"
                          className="w-[286px] h-[42px] rounded-[5px] placeholder:w-[12px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                          placeholder="51"
                        />
                      </div>
                      <div className="flex flex-col h-[68px] items-center text-start justify-between">
                        <h4 className="w-[286px] h-[18px] font-semibold text-start text-black text-[12px]">
                          Height
                        </h4>
                        <input
                          onChange={(text) =>
                            setHeight(text.currentTarget.value)
                          }
                          type="text"
                          className="w-[286px] h-[42px] rounded-[5px] placeholder:w-[12px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] p-[12px] border"
                          placeholder="51"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="w-[948px] h-auto bg-white rounded-[10px] py-[20px] pl-[24px] pr-[20px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={togglePolicy}
              >
                <h4 className="w-[113px] h-[21px] text-[#FF6300] font-semibold text-[14px]">
                  Product Policies
                </h4>
                <button className="w-[31px] h-[31px] bg-white rounded-full border flex items-center justify-center">
                  <svg
                    width="19"
                    height="19"
                    className={`w-6 h-6 transition-transform duration-300 transform ${isOpen5 ? "rotate-0" : "rotate-180"
                      }`}
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.07129 11.6111L9.34907 6.33331L14.6268 11.6111"
                      stroke="#FF6300"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              {isOpen5 && (
                <>
                  <div className="w-[904px] h-[478px] mt-[15px] flex flex-col">
                    <div className="w-[214px] h-[18px] flex item-center justify-between">
                      <input
                        id="default-checkbox"
                        type="checkbox"
                        value=""
                        className="w-4 h-4 text-[#FF6300] bg-[#FF6300] border-gray-300 rounded focus:ring-[#FF6300] dark:ring-offset-[#FF6300]"
                      />
                      <label
                        for="default-checkbox"
                        className="w-[188px] h-[18px] font-semibold text-[14px] text-black text-end"
                      >
                        Set Product based policies
                      </label>
                    </div>
                    <h3 className="w-[258px] h-[18px] font-semibold text-[12px] text-black text-start mt-[21px]">
                      A) Cancellation / Return / Exchange Policy
                    </h3>
                    <textarea
                      onChange={(text) => setCancelPolicy(text.target.value)}
                      name="CancelPolicy"
                      id="CancelPolicy"
                      rows={5}
                      placeholder="Mention your policies"
                      className="w-[904px] h-[101px] p-[12px] border rounded-[5px] placeholder:w-[874px] placeholder:h-[71px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black resize-none mt-[8px]"
                    ></textarea>
                    <h3 className="w-[99px] h-[18px] font-semibold text-[12px] text-black text-start mt-[23px]">
                      B) Refund Policy
                    </h3>
                    <textarea
                      onChange={(text) => setRefundPolicy(text.target.value)}
                      name="CancelPolicy"
                      id="CancelPolicy"
                      rows={5}
                      placeholder="Mention your policies"
                      className="w-[904px] h-[101px] p-[12px] border rounded-[5px] placeholder:w-[874px] placeholder:h-[71px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black resize-none mt-[8px]"
                    ></textarea>
                    <h3 className="w-[112px] h-[18px] font-semibold text-[12px] text-black text-start mt-[35px]">
                      C) Shipping Policy
                    </h3>
                    <textarea
                      onChange={(text) => setShippingPolicy(text.target.value)}
                      name="CancelPolicy"
                      id="CancelPolicy"
                      rows={5}
                      placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "
                      className="w-[904px] h-[101px] p-[12px] border rounded-[5px] placeholder:w-[874px] placeholder:h-[71px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black resize-none mt-[8px] leading-[24px]"
                    ></textarea>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="w-full h-[38px] flex flex-row gap-x-[18px] items-center justify-center mt-[39px]">
            <button
              className="w-[120px] h-[38px] bg-[#FF6300] rounded-[5px] font-semibold text-[12px] text-white"
              onClick={handleCreateProduct}
            >
              Submit
            </button>
            {submitForm && (
              <>
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-[10px] w-[929px] h-[385px] flex flex-col pt-[64px] pb-[52px] items-center justify-center gap-y-[32px]">
                    <p className="w-[107px] h-[107px] bg-[#0097B2] flex items-center justify-center rounded-full">
                      <svg
                        width="60"
                        height="46"
                        viewBox="0 0 60 46"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.1983 42.8495C21.5731 43.477 20.6874 44 19.9059 44C19.1245 44 18.2388 43.4509 17.5876 42.8233L3 28.1805L7.63676 23.5261L19.932 35.868L52.4414 3L57 7.73278L22.1983 42.8495Z"
                          fill="white"
                          stroke="white"
                          stroke-width="3"
                        />
                      </svg>
                    </p>
                    <p className="w-[415px] h-[60px] text-center leading-[30px] font-semibold text-[16px] text-black">
                      Your product is under approval. <br /> Once approved ,
                      your product will be published.
                    </p>
                    <div className="w-[357px] h-[38px] flex flex-row items-center justify-between">
                      <button className="w-[164px] h-[38px] text-white bg-[#FF6300] rounded-[5px] font-semibold text-[14px] flex items-center justify-center">
                        + Add New Product
                      </button>
                      <button className="w-[174px] h-[38px] border gap-x-[10px] flex items-center justify-center rounded-[5px]">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1253_11083)">
                            <path
                              d="M10.0026 2.5L16.6693 6.25V13.75L10.0026 17.5L3.33594 13.75V6.25L10.0026 2.5Z"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 10L16.6667 6.25"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.83594 8.16537L13.1693 4.33203"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 10V17.5"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.0026 10L3.33594 6.25"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1253_11083">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <p className="w-[122px] h-[21px] font-semibold text-[14px] text-black">
                          View all Products
                        </p>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            <button
              className="w-[147px] h-[38px] font-semibold text-[12px] border rounded-[5px] text-black bg-white"
              onClick={toggleViewProduct}
            >
              Preview Product
            </button>
            {viewProduct && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                <div className="w-[985px] h-[733px] bg-white rounded-[10px]">
                  <div className="w-[985px] h-[485px] pt-[36px] pr-[31px] pl-[43px] pb-[31px] flex flex-col">
                    <div className="w-full flex flex-row items-start justify-between">
                      <h3 className="w-[131px] h-[24px] text-[#FF6300] font-semibold text-[16px]">
                        Product Preview
                      </h3>
                      <button onClick={toggleViewProduct}>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.7678 15.0003L20.884 10.884C21.1117 10.6483 21.2377 10.3325 21.2349 10.0048C21.232 9.67702 21.1005 9.3635 20.8688 9.13174C20.637 8.89998 20.3235 8.76852 19.9958 8.76567C19.668 8.76282 19.3523 8.88882 19.1165 9.11652L15.0003 13.2328L10.884 9.11652C10.6483 8.88882 10.3325 8.76282 10.0048 8.76567C9.67702 8.76852 9.3635 8.89998 9.13174 9.13174C8.89998 9.3635 8.76852 9.67702 8.76567 10.0048C8.76282 10.3325 8.88882 10.6483 9.11652 10.884L13.2328 15.0003L9.11652 19.1165C8.88882 19.3523 8.76282 19.668 8.76567 19.9958C8.76852 20.3235 8.89998 20.637 9.13174 20.8688C9.3635 21.1005 9.67702 21.232 10.0048 21.2349C10.3325 21.2377 10.6483 21.1117 10.884 20.884L15.0003 16.7678L19.1165 20.884C19.3523 21.1117 19.668 21.2377 19.9958 21.2349C20.3235 21.232 20.637 21.1005 20.8688 20.8688C21.1005 20.637 21.232 20.3235 21.2349 19.9958C21.2377 19.668 21.1117 19.3523 20.884 19.1165L16.7678 15.0003Z"
                            fill="white"
                          />
                          <path
                            d="M23.8349 6.16376C22.6818 4.96988 21.3025 4.0176 19.7774 3.36249C18.2524 2.70738 16.6121 2.36255 14.9524 2.34813C13.2926 2.33371 11.6466 2.64998 10.1104 3.27849C8.57422 3.907 7.17857 4.83516 6.00492 6.00882C4.83126 7.18248 3.90309 8.57813 3.27458 10.1143C2.64607 11.6505 2.3298 13.2965 2.34422 14.9563C2.35864 16.616 2.70347 18.2563 3.35859 19.7813C4.0137 21.3064 4.96597 22.6857 6.15985 23.8388C7.31294 25.0326 8.69225 25.9849 10.2173 26.64C11.7423 27.2951 13.3826 27.64 15.0423 27.6544C16.7021 27.6688 18.3481 27.3525 19.8843 26.724C21.4205 26.0955 22.8161 25.1674 23.9898 23.9937C25.1634 22.82 26.0916 21.4244 26.7201 19.8882C27.3486 18.352 27.6649 16.706 27.6505 15.0462C27.6361 13.3865 27.2912 11.7463 26.6361 10.2212C25.981 8.69615 25.0287 7.31684 23.8349 6.16376ZM20.8811 19.1175C21.0005 19.2328 21.0957 19.3707 21.1612 19.5233C21.2267 19.6758 21.2612 19.8398 21.2627 20.0058C21.2641 20.1717 21.2325 20.3363 21.1696 20.4899C21.1068 20.6436 21.014 20.7831 20.8966 20.9005C20.7792 21.0179 20.6397 21.1107 20.486 21.1735C20.3324 21.2364 20.1678 21.268 20.0019 21.2666C19.8359 21.2651 19.6719 21.2306 19.5193 21.1651C19.3668 21.0996 19.2289 21.0044 19.1136 20.885L14.9974 16.7688L10.8811 20.885C10.6453 21.1127 10.3296 21.2387 10.0019 21.2359C9.6741 21.233 9.36059 21.1015 9.12883 20.8698C8.89707 20.638 8.76561 20.3245 8.76276 19.9968C8.75991 19.669 8.8859 19.3533 9.1136 19.1175L13.2299 15.0013L9.1136 10.885C8.8859 10.6493 8.75991 10.3335 8.76276 10.0058C8.76561 9.67801 8.89707 9.36449 9.12883 9.13273C9.36059 8.90097 9.6741 8.76951 10.0019 8.76667C10.3296 8.76382 10.6453 8.88981 10.8811 9.11751L14.9974 13.2338L19.1136 9.11751C19.3494 8.88981 19.6651 8.76382 19.9929 8.76667C20.3206 8.76951 20.6341 8.90097 20.8659 9.13273C21.0976 9.36449 21.2291 9.67801 21.2319 10.0058C21.2348 10.3335 21.1088 10.6493 20.8811 10.885L16.7649 15.0013L20.8811 19.1175Z"
                            fill="#FF6300"
                          />
                        </svg>
                      </button>
                    </div>

                    <div className="w-full h-[370px] flex flex-row mt-[18px]">
                      <div className="flex flex-col gap-y-[16px] w-[276px]">
                        <div className="w-[276px] h-[295px] border rounded-[10px] p-[20px] flex items-center justify-center">
                          <div className="flex items-center justify-center">
                            <img
                              // src={productData?.image[0]}
                              src={files[0]?.name}
                              alt="mainImg"
                              className="w-[149px] h-[183px]"
                            />
                          </div>
                        </div>

                        <div className="flex flex-row gap-x-[10px] w-[276px]">
                          {files.map((file, index) => (
                            <button
                              onClick={() => handleImageClick(index)} // Call handleImageClick function on button click
                              key={index}
                              style={{
                                borderColor: color === index && "#FF8100",
                              }}
                              className="w-[62px] h-[59px] bg-white border-[2px] rounded-[5px] flex items-center justify-center"
                            >
                              <img src={file?.imgSrc} alt={file.alt} />
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="w-[589px] h-[261px] flex flex-col ml-[25px] mt-[21px]">
                        <h2 className="w-[351px] h-[24px] text-black font-semibold text-[16px]">
                          {productTitle}
                        </h2>
                        <div className="flex gap-x-[6px] items-center mt-[15px]">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.30671 18.7119C8.06657 18.7138 7.82847 18.6678 7.60633 18.5766C7.38418 18.4853 7.18246 18.3507 7.01296 18.1806L1.71296 12.8806C1.53366 12.701 1.39381 12.4859 1.30233 12.2492C1.21086 12.0124 1.16977 11.7592 1.18171 11.5056C1.21272 10.9912 1.43577 10.5072 1.80671 10.1494L10.0005 1.94939C10.1909 1.7487 10.4208 1.58958 10.6757 1.48203C10.9307 1.37447 11.2051 1.3208 11.4817 1.32439L16.6567 1.45564C17.1265 1.46542 17.5738 1.65852 17.9031 1.99369C18.2325 2.32885 18.4177 2.77951 18.4192 3.24939L18.5505 8.41814C18.5527 8.69552 18.4984 8.97044 18.391 9.22617C18.2835 9.48191 18.1251 9.71309 17.9255 9.90564L9.74421 18.1244C9.38863 18.4984 8.90331 18.7221 8.38796 18.7494L8.30671 18.7119ZM7.90046 17.2994C7.95774 17.3559 8.02635 17.3996 8.10177 17.4276C8.17719 17.4556 8.25769 17.4673 8.33796 17.4619C8.5339 17.448 8.71818 17.3637 8.85671 17.2244L17.063 9.01814C17.1386 8.94535 17.1986 8.85795 17.2394 8.76126C17.2803 8.66457 17.301 8.56059 17.3005 8.45564L17.1692 3.28064C17.1692 3.13311 17.1106 2.99163 17.0063 2.88731C16.902 2.78299 16.7605 2.72439 16.613 2.72439L11.438 2.59314C11.3332 2.59363 11.2295 2.61487 11.133 2.65564C11.0364 2.6964 10.9489 2.75588 10.8755 2.83064L2.66921 11.0369C2.52993 11.1754 2.44556 11.3597 2.43171 11.5556C2.42631 11.6359 2.438 11.7164 2.46601 11.7918C2.49403 11.8672 2.53772 11.9359 2.59421 11.9931L7.90046 17.2994Z"
                              fill="black"
                              stroke="black"
                              stroke-width="0.5"
                            />
                            <circle
                              cx="13.5"
                              cy="6.5"
                              r="1.5"
                              stroke="black"
                              stroke-width="1.5"
                            />
                          </svg>
                          <p className="w-[200px] h-[24px] font-semibold text-[16px]">
                            Price: ₹ {maxPrice} / unit
                          </p>
                        </div>
                        <div className="w-[161px] h-[34px] border rounded-[5px] flex items-center justify-center font-semibold text-[12px] mt-[22px]">
                          Category : {selectedOption.label}
                        </div>
                        <div className="w-[589px] h-[120px] leading-[24px] text-[12px] font-medium mt-[25px]">
                          <ul className="list-disc font-medium text-[12px]">
                            <li>{shortDesc}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-full h-[248px] bg-[#F8F8F8] rounded-b-[10px] flex flex-col pt-[42px] pl-[43px] pb-[59px] pr-[34px]">
                    <h4 className="w-[141px] h-[21px] font-semibold text-[14px] text-black text-start">
                      Product Description
                    </h4>
                    <hr className="w-[181px] h-[2px] pb-[3px] bg-[#FF6300] rounded-full mt-[10px]" />
                    <p className="w-[907px] h-[96px] font-medium text-[12px] text-start text-black leading-[24px] mt-[18px]">
                      {longDesc}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MyProducts;
